
import { Route, Routes, useNavigate} from 'react-router-dom';
import { StandardViewPanel } from '../../../_components/panel/standardView.panel';
import { CentreDetailsManageDrawer } from './centre-detailsManageDrawer';


export const CentreDetailsPanel = ({data, isLoading, onRefresh}: any) => {

    const navigate = useNavigate();

    const rows = [
        { label: 'Name', value: data.name },
        { label: 'Manager', value: data.centreManagerName },
        { label: 'Address', value: data.address },
        { label: 'Telephone', value: data.telephone },
        { label: 'Mobile', value: data.mobile },
        { label: 'Email', value: data.email },
        { label: 'Fax', value: data.fax },
        { label: 'Fire Alarm Code', value: data.fireAlarmCode },
        { label: 'House Alarm Code', value: data.houseAlarmCode },
        { label: 'IP', value: data.ip },
        { label: 'Share Point URL', value: data.sharePointUrl },
        { label: 'Email Password', value: data.emailPassword },


    ]

    return (
        <>
            <StandardViewPanel
                title="Centre Details" buttons={[
                    { icon: "edit", onClick: () => { navigate("ManageDetails/") }}
                ]}
                loading={isLoading}
                items={rows} />

            <Routes>
                <Route path="ManageDetails/" element={<CentreDetailsManageDrawer onSave={() => { navigate(""); onRefresh(); }} onClose={() => { navigate(""); onRefresh(); }} />} />
            </Routes>
        </>
    );
};